<template>
  <div>
      <div class="columns">
          <div class="column has-text-centered">
            <h1 class="has-text-white is-size-3">
                HEADER UTILITIES
            </h1>
          </div>
      </div>
      <div class="columns">
          <div class="column">
                <div class="columns is-centered">
                    <div class="column is-four-fifths">
                        <b-field label="Header Text">
                            <b-input class="has-background-dvodark" type="textarea" v-model="importantUpdate">
                            </b-input>
                        </b-field>
                        <b-field label="Marketing Material Link">
                            <b-input class="has-background-dvodark" v-model="marketingMaterial"></b-input>
                        </b-field>
                        <b-field label="Tech News Link">
                            <b-input class="has-background-dvodark" v-model="techLinks"></b-input>
                        </b-field>
                        <b-button class="is-dvogreen" @click="updateUtils()">Update</b-button>
                    </div>
                </div>
          </div>
      </div>
  </div>
</template>

<script>
import { API  } from 'aws-amplify'
import { adminUtilHandler } from '../graphql/mutations'
export default {
    data() {
        return {
            importantUpdate: null,
            marketingMaterial: null,
            techLinks: null,
        }
    },
    methods: {
        async getUtils() {
            const Util = {
                id: 1,
                request_type: 'read_one'
            };
            const utils = await API.graphql({
                query: adminUtilHandler,
                variables: {
                    input: Util,
                },
            });
            this.importantUpdate = utils.data.adminUtilHandler.important_update
            this.marketingMaterial = utils.data.adminUtilHandler.marketing_material
            this.techLinks = utils.data.adminUtilHandler.tech_news
        },
        async updateUtils() {
            const Util = {
                id: 1,
                important_update: this.importantUpdate,
                marketing_material: this.marketingMaterial,
                tech_news: this.techLinks,
                request_type: 'update'
            };
            const utils = await API.graphql({
                query: adminUtilHandler,
                variables: {
                    input: Util
                },
            });
            this.importantUpdate = utils.data.adminUtilHandler.important_update
            this.marketingMaterial = utils.data.adminUtilHandler.marketing_material
            this.techLinks = utils.data.adminUtilHandler.tech_news
        },
    },
    beforeMount() {
        this.getUtils();
    }
}
</script>

<style>

</style>